import { Transition } from 'react-transition-group';
import { AlertPopupContainer } from '../../../components/alert-popup/alertPopup.styled';
import Button from '../../../components/button';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';
import { type AccessProfileScope } from './types';

interface AccessProfileDeleteConfirmModalProps {
  scope: AccessProfileScope;
  isShow: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  message: string;
  isAssigned?: boolean;
  loading?: boolean;
}

const AccessProfileDeleteConfirmModal = ({
  scope,
  isShow,
  message,
  isAssigned,
  handleClose,
  handleSubmit,
  loading,
}: AccessProfileDeleteConfirmModalProps): JSX.Element => {
  return (
    <Transition in={isShow} timeout={250}>
      {(state) => (
        <AlertPopupContainer id={`delete${scope}ModalOverlay`}>
          <div className={`modalBackdrop modalBackdrop-${state}`} id={`delete${scope}ModalContainer`}>
            <div className={`sideBar sideBar-${state} `}>
              <div className='popupDialog'>
                <div
                  className='popupContent'
                  id={`delete${scope}ModalBody`}
                  style={
                    isAssigned
                      ? { borderTop: `4px solid ${COLORS.Red}`, background: COLORS.LightRed }
                      : undefined
                  }>
                  {isAssigned && (
                    <div className='flex items-center gap-2 mb-3'>
                      <span
                        className='material-symbols-outlined'
                        style={{ color: COLORS.Red, fontSize: '24px' }}>
                        warning
                      </span>
                      <Heading
                        variant='h6'
                        title='Warning'
                        id={`delete${scope}WarningLabel`}
                        style={{ color: COLORS.Red, margin: 0 }}
                      />
                    </div>
                  )}
                  <Heading
                    variant='h5'
                    className='mb-5'
                    title={message}
                    id={`delete${scope}ModalTitle`}
                  />

                  <div className='popupButtons'>
                    <Button
                      variant='primary-dark'
                      title='Close'
                      onClick={handleClose}
                      id={`delete${scope}ModalCancel`}
                    />
                    <Button
                      variant={isAssigned ? 'primary-danger' : 'primary'}
                      title='Confirm'
                      onClick={handleSubmit}
                      icon={<span className='material-symbols-outlined'>check_circle</span>}
                      loading={loading}
                      id={`delete${scope}ModalConfirm`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default AccessProfileDeleteConfirmModal;
